/**
* @Author: Matthias Gohla <Matze>
* @Date:   2016-09-23T12:06:03+02:00
* @Email:  matze_lebt@gmx.de
* @Last modified by:   Matze
* @Last modified time: 2016-09-26T11:37:57+02:00
*/

import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * OBodyCheckout - wraps the whole checkout form
 * pass in OFormareaCheckout and OSidebarCheckout as children
**/
class OBodyCheckout extends Component {
  /**
     * TODO jsdoc
     *
     * @return {object}
     */
  render() {
    const {
      children,
    } = this.props;
    return (
		        <div className={'o-body o-body-checkout clearfix ' + (window && window.parent != window ? '' : 'not-framed')}>
		            {children}
		        </div>
		    );
  }
}

OBodyCheckout.propTypes = {
  children: PropTypes.any,
};
OBodyCheckout.defaultProps = {};
export default OBodyCheckout;

